<template>
  <div class="SiteContent">

    <slot></slot>

  </div>
</template>

<script>
export default {
  name: 'SiteContent'
}
</script>

<style>
@import 'properties';

.SiteContent {
  flex-grow: 1;
  margin-bottom: var(--unit-2);
}
</style>



// WEBPACK FOOTER //
// SiteContent.vue?577ee5c8